import React from "react";
import { Button, Container } from "react-bootstrap";
import "../App.css";

const Hero = () => {
  return (
    <div id="hero" className="hero">

      {/* 🔥 Background Image */}
      <img
        src="/banner-review5.webp"
        alt="Hero Background"
        className="hero-bg"
        loading="eager"
      />

      <Container className="d-flex flex-column align-items-end hero-container">
        <div className="hero-content d-flex flex-column align-items-end text-end">

          <img
            src="/logo-removebg-preview.png"
            alt="Logo"
            className="hero-logo"
          />

          <Button className="hero-btn" href="#contact">
            Speak to an Attorney
          </Button>

        </div>
      </Container>

    </div>
  );
};

export default Hero;
